import { scrollTo } from '../common/utils';

const reverse = function () {
    return $($(this).get().reverse());
};

const preciseWidth = function () {
    return $(this).get(0).getBoundingClientRect().width;
};

const preciseHeight = function () {
    return $(this).get(0).getBoundingClientRect().height;
};

const scrollIntoView = function (options = {}) {
    scrollTo($(this), options);

    return $(this);
};

const register = () => {
    $.fn.reverse = reverse;

    $.fn.preciseWidth = preciseWidth;
    $.fn.preciseHeight = preciseHeight;

    $.fn.scrollIntoView = scrollIntoView;
};

export default {
    register,
};

